import { axios } from '@/services/axios';

const getAllTRSRegistrationsByCompanyId = async (accountScope, companyID) => {
    const endpoint = `/TRSRegistrations/Available/${companyID}`;
    const res = await axios.get(endpoint, {
        headers: {
            'X-RequestScope': accountScope,
        },
    });
    return res.data;
};

export default getAllTRSRegistrationsByCompanyId;
